import React, { useEffect } from "react";

const ProblemInput = ({ problem, setProblem, onSubmit, isLoading }) => {
  // Effect to save the problem to localStorage whenever it changes
  useEffect(() => {
    // We still keep the localStorage logic for user convenience,
    // but the source of truth for the component is now the prop.
    localStorage.setItem("problemInput", problem);
  }, [problem]);

  // Load initial value from localStorage only if the prop is empty
  useEffect(() => {
    if (!problem) {
      const savedProblem = localStorage.getItem("problemInput") || "";
      setProblem(savedProblem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once on mount

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(); // The actual submission logic is in the parent
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
      <h2 className="text-xl font-bold mb-4 dark:text-white">
        What problem are you trying to solve?
      </h2>

      <form onSubmit={handleSubmit}>
        <textarea
          className="input w-full h-32 mb-4 resize-none"
          placeholder=""
          value={problem}
          onChange={(e) => setProblem(e.target.value)}
          disabled={isLoading}
        ></textarea>

        <div className="flex justify-end">
          <button
            type="submit"
            className="btn btn-primary flex items-center"
            disabled={isLoading || !problem.trim()}
          >
            {isLoading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Generating...
              </>
            ) : (
              "Generate Provocations"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProblemInput;
